/* eslint-disable no-use-before-define */
import { IdName } from 'src/app/shared/models/id-name';
import { UiAutocompleteOption } from 'src/app/shared/ui-elements/ui-autocomplete/ui-autocomplete.component';
import { Observable } from 'rxjs';
import { IAttachment } from 'src/app/shared/attachments/models/attachments.model';
import { TripStatus } from '../enums/trip-status.enum';
import { PlannedActivityUserTripStatus } from '../enums/planned-activity-user-trip-status.enum';
import { ITripPax } from './pax-overview/pax-overview.model';
import { IPlannedActivityFromBasicTrip } from './planned-activities/planned-activity.model';

interface ITrip {
  id: string;
  name: string;
  description: string;
  from: Date;
  to: Date;
  activity: IdName;
  shift: IdName;
  status: TripStatus;
  key: TripStatus;
  signOffOverdue: boolean;
}

export interface ITripRequest extends ITrip {
  userIds: string[];
}

export interface ITripCreate extends ITrip {
  name: string;
  description: string;
  startDate: Date;
  endDate: Date;
  viewStatus: TripStatus;
}

export interface ITripPlannedActivityUser {
  plannedActivityId: string;
  userId: string;
  name: string;
  position: IdName;
  from: Date;
  to: Date;
  status: PlannedActivityUserTripStatus;
  watchDuties: boolean;
  lastMonthSignedDocumentPeriodDate: Date | null;
}

export interface ITripResponse extends ITrip {
  department: IdName;
  plannedActivities: ITripPlannedActivityUser[];
  paxes: ITripPax[];
  attachments: IAttachment[];
  doesEveryoneHaveSignedOffWorkAndRestDocument: boolean;
  doesAnyoneHaveSignedLastMonthWorkAndRestDocument: boolean;
  doesEveryoneHaveCompletedWorkAndRestDocumentation: boolean;
}

export interface ITripGroupData {
  address: string;
  itemsOnNode: ITripResponse[];
}

export interface ITripOnNodeDisplay extends ITripResponse {
  isSubHeader?: boolean;
  address?: string | Observable<string>;
  statusDisplayName?: string;
}

export interface IApiResponseGroupTrips {
  data: ITripResponse[];
  totalPages: number;
  totalItems: number;
  groupData: ITripGroupData[];
}

export interface IAvailableTrip extends IdName {
  from: string;
  to: string;
  viewStatus: TripStatus;
}

export interface IBasicTrip {
  activity: IdName;
  attachments: IAttachment[];
  department: IdName;
  description: string;
  from: string;
  id: string;
  name: string;
  paxes: ITripPax[];
  plannedActivities: IPlannedActivityFromBasicTrip[];
  shift: IdName;
  status: TripStatus;
  to: string;
}

export interface ITripLog {
  tripVersionReason: string;
  createdBy: string;
  date: string;
  fieldsChanged: ITripLogFieldChange[];
  crewMembersChanges: {
    name: string;
    from: string;
    to: string;
  }[];
}

export interface ITripLogFieldChange {
  fieldName: string;
  value: string;
}
export interface ICrewMemberUpdate {
  onBoardData: {
    id: string | null;
    positionId: string;
    from: string;
    to: string;
    comment: string;
  }[];
}

export interface IPaxUpdate {
  paxes: {
    paxOverviewId: string | null;
    startDate: string;
    endDate: string;
  }[];
}

export type AvailableTripOption = IAvailableTrip & UiAutocompleteOption;
export type TripOption = ITripResponse & UiAutocompleteOption;
export const TRIP_STATUS_CLASSES: any = {
  [TripStatus.Active]: 'active',
  [TripStatus.Completed]: 'completed',
  [TripStatus.Inactive]: 'inactive',
};

export interface ITripChangeLog {
  trip: IdName;
  logData: ITripLog;
}
